import dbServices from 'api/dbServices'
import common from 'config/common'
import i18n from 'plugins/i18n'

export default {
    state: {
        allowlist: [],
        allowlistLoading: false,
        allowlistUpdatingAddress: null,
    },
    mutations: {
        setAllowList(state, allowlist) {
            state.allowlist = allowlist
        },
        setAllowListLoading(state, payload) {
            state.allowlistLoading = payload
        },
        setAllowlistUpdatingAddress(state, payload) {
            state.allowlistUpdatingAddress = payload
        },
    },
    actions: {
        async fetchAllowList({ commit,}, serviceId) {
            commit('setAllowList', [])
            commit('setAllowListLoading', true)
            try {
                const { data, } = await dbServices.get(`services/${serviceId}/security/allowlist`)
                commit('setAllowList', data.length && data[0].allow_list ? data[0].allow_list : [])
            } catch (error) {
                commit('setAllowListLoading', false)
                commit('showMessage', { text: i18n.t('unableFetchAllowList'), type: common.messageType.ERROR, })
            }
            commit('setAllowListLoading', false)
        },

        async updateAddressToAllowList({ commit, dispatch,}, { serviceId, allowList, }) {
            commit('setAllowlistUpdatingAddress', true)
            try {
                const { data, } = await dbServices.put(`services/${serviceId}/security/allowlist`, allowList)
                commit('setAllowList',  data.length && data[0].allow_list ? data[0].allow_list : allowList)
                dispatch('fetchServices', null, { root: true, })
            } catch (error) {
                commit('setAllowlistUpdatingAddress', null)
                commit('showMessage', { text: i18n.t('unableSaveAllowList'), type: common.messageType.ERROR, })
            }
            commit('setAllowlistUpdatingAddress', false)
        },
    },
    getters: {
        allowlist: (state) => state.allowlist,
        allowlistLoading: (state) => state.allowlistLoading,
        allowlistUpdatingAddress: (state) => state.allowlistUpdatingAddress,
    },
}
